import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { handleGetRequest } from "../../services/GetTemplate";
import { Button } from "primereact/button";
import FileUploadStatusDetail from "./FileUploadStatusDetail";
import FileCommentsBtn from "./FileCommentsBtn";
import FileStatusesExcelDownload from "./FileStatusesExcelDownload";
import { OverlayPanel } from "primereact/overlaypanel";
import styled from "styled-components";
import { handlePostRequest } from "../../services/PostTemplate";
import { useHistory } from "react-router-dom";

function FileStatuses() {
  const [loading, setloading] = useState(false);
  const [fileStausData, setfileStausData] = useState([]);
  const [fileHeadId, setfileHeadId] = useState(null);
  const [fileStatusData, setFileStatusData] = useState([null]);
  const [currentBatchId, setCurrentBatchId] = useState(null);
  const [currentfileUploadBy, setCurrentfileUploadBy] = useState(null);
  const [rows, setRows] = useState(20);
  const [first, setFirst] = useState(0);

  let history = useHistory();

  const op = React.createRef();
  const batchIdToolTip = React.createRef();
  const fileUploadByToolTip = React.createRef();

  const getFileStatus = async () => {
    setloading(true);
    const res = await handleGetRequest(
      "zbizgateway/fileStatusCheck/fileUploadStatusCheck"
    );
    setfileStausData(res?.data);
    setloading(false);
  };

  const handleRetry = async (incomingFileheadId) => {
    const data = {
      fileHeadId: incomingFileheadId,
      authDetailId: "",
      action: "",
      comments: "",
    };
    await handlePostRequest(data, "zbizgateway/retryuploadedfile");
  };

  const actionTemplate = (rowData) => {
    if (rowData?.fileStatusCode === "I") {
      return (
        <div style={{ display: "flex", justifyContent: "flex-start" }}>
          <FileCommentsBtn fileHeadId={rowData?.fileHeadId} />
        </div>
      );
    }
    return (
      <div style={{ display: "flex", justifyContent: "flex-start" }}>
        <FileCommentsBtn fileHeadId={rowData?.fileHeadId} />
        {rowData?.mcStatus === "A" && rowData?.processedRecords > 0 && (
          <Button
            icon="pi pi-refresh"
            alt="Retry"
            onClick={() => handleRetry(rowData?.fileHeadId)}
            className="p-button-rounded  p-mr-1"
          />
        )}
        <Button
          icon="pi pi-eye"
          onClick={() => handleButtonClick(rowData)}
          className="p-button-rounded p-button-info"
        />
      </div>
    );
  };

  const handleButtonClick = (rowData) => {
    setfileHeadId(rowData?.fileHeadId);
    setFileStatusData(rowData);
  };

  const statusTemplate = (rowData) => {
    let statusElement;
    let percentage;

    switch (rowData?.fileStatusCode) {
      case "I":
        statusElement = (
          <div
            // style={{ display: "flex", justifyContent: "flex-start" }}
            title="Initial Upload"
          >
            {/* <FaFileAlt style={{ color: "blue", marginRight: "5px" }} /> */}
            <span style={{ color: "blue" }}>Initial Upload</span>
          </div>
        );
        break;
      case "F":
        statusElement = (
          <div
            // style={{ display: "flex", justifyContent: "flex-start" }}
            title="Fail"
          >
            {/* <FaTimesCircle style={{ color: "red", marginRight: "5px" }} /> */}
            <small style={{ color: "red" }}>
              {rowData?.limitStatus || rowData?.coreToGLStatus || "Fail"}
            </small>
          </div>
        );
        break;
      case "P":
        statusElement = (
          <div
            // style={{ display: "flex", justifyContent: "flex-start" }}
            title="Pending"
          >
            {/* <FaClock style={{ color: "orange", marginRight: "5px" }} /> */}
            <span style={{ color: "orange" }}>Pending</span>
          </div>
        );
        break;
      case "S":
        statusElement = (
          <div
            // style={{ display: "flex", justifyContent: "flex-start" }}
            title="Success"
          >
            {/* <FaCheckCircle style={{ color: "green", marginRight: "5px" }} /> */}
            <span style={{ color: "green" }}>Success</span>
          </div>
        );
        break;
      case "A":
        statusElement = (
          <div
            // style={{ display: "flex", justifyContent: "flex-start" }}
            title="Approved"
          >
            {/* <FaCheckCircle style={{ color: "green", marginRight: "5px" }} /> */}
            <span style={{ color: "green" }}>Approved</span>
          </div>
        );
        break;
      case "D":
        statusElement = (
          <div
            // style={{ display: "flex", justifyContent: "flex-start" }}
            title="Done"
          >
            {/* <FaCheckCircle style={{ color: "green", marginRight: "5px" }} /> */}
            <span style={{ color: "green" }}>Done</span>
          </div>
        );
        percentage = 100; // Force 100% for "D" status
        break;
      case "R":
        statusElement = (
          <div
            // style={{ display: "flex", justifyContent: "flex-start" }}
            title="Rejected"
          >
            {/* <FaTimesCircle style={{ color: "red", marginRight: "5px" }} /> */}
            <span style={{ color: "red" }}>Rejected</span>
          </div>
        );
        break;
      default:
        statusElement = null;
    }

    // Calculate percentage if it's not already set (for "D" status)
    if (percentage === undefined) {
      const successRecords =
        rowData?.transSuccessRecords !== 0
          ? rowData?.transSuccessRecords
          : rowData?.processedRecords;
      percentage = ((100 * successRecords) / rowData?.totalRecords).toFixed(0);
    }

    return (
      <>
        {statusElement}
        <hr />
        {percentage}%
      </>
    );
  };

  const fileUploadBy = (rowData) => {
    const fileUploadBy = rowData?.fileUploadBy.slice(0, 6);
    return (
      <div>
        <p
          onMouseEnter={(e) => {
            setCurrentfileUploadBy(rowData?.fileUploadBy);
            fileUploadByToolTip.current.toggle(e);
          }}
          onMouseLeave={() => fileUploadByToolTip.current.hide()}
          className="custom-tooltip-target"
          style={{ cursor: "pointer" }}
        >
          {fileUploadBy} ...
        </p>
      </div>
    );
  };

  const fileUploadByTooltipContent = (
    <OverlayPanel ref={fileUploadByToolTip}>
      <p>{currentfileUploadBy && currentfileUploadBy}</p>
    </OverlayPanel>
  );

  // const batchId = (rowData) => {
  //   const batchId = rowData?.batchId.slice(0, 6)
  //   return (
  //     <div onClick={() => navigator.clipboard.writeText(rowData?.batchId)}>
  //       <p onMouseEnter={(e) => {
  //         setCurrentBatchId(rowData?.batchId);
  //         batchIdToolTip.current.toggle(e);
  //       }}
  //         onMouseLeave={() => batchIdToolTip.current.hide()}
  //         className="custom-tooltip-target" style={{ cursor: 'pointer' }}><i className="pi pi-copy hover_copy" style={{ fontSize: "20px", color: "orange" }} /> {batchId}...</p>
  //     </div>
  //   )
  // }

  const batchIdTooltipContent = (
    <OverlayPanel ref={batchIdToolTip}>
      <p>{currentBatchId && currentBatchId}</p>
    </OverlayPanel>
  );

  const statusHeader = (
    <div
      onMouseEnter={(e) => op.current.toggle(e)}
      onMouseLeave={() => op.current.hide()}
      className="custom-tooltip-target"
    >
      Status
    </div>
  );

  const tooltipContent = (
    <OverlayPanel ref={op}>
      <TooltipTable>
        <thead>
          <TooltipRow>
            <TooltipHeader>Status</TooltipHeader>
            <TooltipHeader>Description</TooltipHeader>
          </TooltipRow>
        </thead>
        <tbody>
          <TooltipRow>
            <TooltipData>Initial File Upload</TooltipData>
            <TooltipData>Basic CNIC/Account No Duplicate Checks</TooltipData>
          </TooltipRow>
          <TooltipRow>
            <TooltipData>Pending</TooltipData>
            <TooltipData>
              File will be in pending during Title fetch/ Account status check
            </TooltipData>
          </TooltipRow>
          <TooltipRow>
            <TooltipData>Success</TooltipData>
            <TooltipData>Basic checks completed</TooltipData>
          </TooltipRow>
          <TooltipRow>
            <TooltipData>Done</TooltipData>
            <TooltipData>Transaction Done</TooltipData>
          </TooltipRow>
        </tbody>
      </TooltipTable>
    </OverlayPanel>
  );

  // const fileStatusHeader = (
  //   <div style={{ display: "flex", justifyContent: "space-between" }}>
  //     <p>File Status</p>
  //     <div style={{ display: "flex", alignItems: "center" }}>
  //       <Button icon="pi pi-refresh" label="Refresh Status" onClick={() => getFileStatus()} className="p-button-raised p-mr-1" />
  //       <FileStatusesExcelDownload data={fileStausData} />
  //     </div>
  //   </div>
  // )

  useEffect(() => {
    getFileStatus();
  }, []);

  // useEffect(() => {
  //   const pendingRecords = fileStausData[0]?.pendingRecords;

  //   if (pendingRecords !== 0) {
  //     const intervalId = setInterval(() => {
  //       getFileStatus();
  //     }, 10000);

  //     return () => clearInterval(intervalId);
  //   }
  // }, [fileStausData]);

  const batchId = (rowData) => {
    return (
      <>
        <p style={{ fontSize: "11px" }}>{rowData?.batchId}</p>
      </>
    );
  };

  const handlePageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  return (
    <>
      <div>
        <div className="page_header">
          <div
            className="Top__Btn"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div className="d_align">
              <i
                className="pi pi-arrow-circle-left mr-1"
                onClick={() => history.goBack()}
              />
              <h3 className="mod_heading">File Status</h3>
            </div>
            <div className="d_align">
              {fileStausData && fileStausData?.length > 0 && (
                <Button
                  icon="pi pi-refresh"
                  label="Refresh Status"
                  onClick={() => getFileStatus()}
                  className="p-button-raised p-mr-1"
                />
              )}
              <FileStatusesExcelDownload data={fileStausData} />
            </div>
          </div>
        </div>
        <div className="card">
          <DataTable
            dataKey="fileHeadId"
            loading={loading}
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={rows}
            first={first}
            rowsPerPageOptions={[10, 20, 50, 100, 200]}
            onPage={handlePageChange}
            value={fileStausData}
            emptyMessage="No data found."
            autoLayout
          >
            <Column filter body={batchId} header="Batch ID" />
            <Column filter field="fileName" header="File Name" />
            <Column filter field="productName" header="Product Name" />
            <Column filter field="fileUploadDate" header="Upload Date" />
            <Column
              filter
              field="fileUploadBy"
              body={fileUploadBy}
              header="Upload By"
            />
            <Column filter field="fileStatusDescr" header="File Status" />
            <Column
              filter
              field="fileStatusCode"
              header={statusHeader}
              body={statusTemplate}
              filterField={(rowData) =>
                rowData?.fileStatusCode === "I"
                  ? "Initial Upload"
                  : rowData?.fileStatusCode === "P"
                  ? "Pending"
                  : rowData?.fileStatusCode === "S"
                  ? "Success"
                  : rowData?.fileStatusCode === "A"
                  ? "MC Approved"
                  : rowData?.fileStatusCode === "D"
                  ? "Done"
                  : rowData?.fileStatusCode === "R"
                  ? "Rejected"
                  : null
              }
              filterMatchMode="contains"
            />
            <Column filter field="totalRecords" header="Total Records" />
            <Column
              filter
              field="processedRecords"
              header="Processed Records"
            />
            <Column filter field="pendingRecords" header="Pending Records" />
            <Column filter field="errorRecords" header="Error Records" />
            <Column
              filter
              field={(item) => (
                <b>
                  {item?.disbursedAmount &&
                    item?.disbursedAmount.toLocaleString("en-PK").split(".")[0]}
                </b>
              )}
              header="Disbursed Amount"
            />
            <Column
              filter
              field={(item) => (
                <b>
                  {item?.balanceBefore &&
                    item?.balanceBefore.toLocaleString("en-PK").split(".")[0]}
                </b>
              )}
              header="Balance Before"
            />
            <Column
              filter
              field={(item) => (
                <b>
                  {item?.balanceAfter &&
                    item?.balanceAfter.toLocaleString("en-PK").split(".")[0]}
                </b>
              )}
              header="Amount To Disburse"
            />
            <Column
              filter
              field="transSuccessRecords"
              header="Success Records"
            />
            <Column
              filter
              field={(item) =>
                item?.transactionDateT24
                  ? item?.transactionDateT24.split("T")[0] +
                    " " +
                    item?.transactionDateT24.split("T")[1].split(".")[0]
                  : ""
              }
              header="Trx Date T24"
            />
            <Column
              body={actionTemplate}
              header="Action"
              style={{ width: "8%" }}
            />
          </DataTable>
        </div>
      </div>
      {tooltipContent}
      {batchIdTooltipContent}
      {fileUploadByTooltipContent}
      <FileUploadStatusDetail
        fileHeadId={fileHeadId}
        fileStatusData={fileStatusData}
      />
    </>
  );
}

const TooltipTable = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

const TooltipHeader = styled.th`
  background-color: #f5f5f5;
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
`;

const TooltipRow = styled.tr`
  &:hover {
    background-color: #f2f2f2;
  }
`;

const TooltipData = styled.td`
  padding: 10px;
  border-bottom: 1px solid #ddd;
`;

export default FileStatuses;
